export class CashRegisterCloseShiftLocalRequest {
    cashRegisterId?: number;
    accessToken?: string;
} 